<div class="one-footer-bar" [class.is-stuck]="isStuck()">
  <div class="one-footer-content">
    <ng-template [cdkPortalOutlet]="footer.portal()"></ng-template>
  </div>
  @if (!ocultarMarcaDagua) {
    <a class="one-footer-brand" [href]="siteUrl" target="_blank" rel="noopener">
      <span class="one-footer-brand-text">Powered by</span>
      <img class="one-footer-brand-logo" [src]="marcaDagua" alt="Powered by" />
    </a>
  }
</div>
<div #sentinel class="one-footer-sentinel" aria-hidden="true"></div>
